import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Cookies from 'universal-cookie';
import styles from './index.scss';

class CookiesBanner extends Component {
  constructor(props) {
    super(props);

    const cookies = new Cookies();

    this.state =  {
      acknowledged: cookies.get('cookie-acknowledged') || false
    }

    this.acknowledge = this.acknowledge.bind(this);
  }

  acknowledge() {
    const cookies = new Cookies();
    cookies.set('cookie-acknowledged', true, {
      expires: new Date((new Date()).getTime() + (1000 * 86400000))
    });
    this.setState({ acknowledged: true });
  }

  render() {
    const { acknowledged } = this.state;

    if (!acknowledged) {
      return (
        <div className={styles.banner}>
          <div className={styles.wrapper}>
            <div className={styles.message}>
              Um unsere Webseite optimal zu gestalten, verwenden wir Cookies, Google Analytics und Dienste von Drittanbietern wie bspw. YouTube. Durch die weitere Nutzung der Webseite stimmen Sie der Verwendung von Cookies und der Analyse Ihrer Daten zu. Weitere Informationen erhalten Sie in unserer <NavLink to='/datenschutz'>Datenschutzerklärung</NavLink>.
            </div>
            <div className={styles.button} onClick={this.acknowledge}>
              Einverstanden
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
}

export default CookiesBanner;



// WEBPACK FOOTER //
// ./src/components/layout/banner/cookies/index.jsx